class ClinchApplicationError extends Error {
  constructor(message: string) {
    super(message);
  }
}

interface ApiError extends Error {
  status: number;
  message: string;
  isCanceled: boolean;
}

export {ClinchApplicationError, ApiError};
